export default {"src":"/ai/_next/static/media/edit_logo.a158a4a1.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};